var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C6.05613 0 0 6.05613 0 13.5C0 20.9433 6.05613 27 13.5 27C20.9433 27 27 20.9433 27 13.5C27 6.05613 20.9444 0 13.5 0ZM16.8573 13.9753H14.661V21.8036H11.4064C11.4064 21.8036 11.4064 17.5262 11.4064 13.9753H9.85936V11.2085H11.4064V9.41889C11.4064 8.13719 12.0155 6.13443 14.6909 6.13443L17.1026 6.14368V8.82943C17.1026 8.82943 15.6371 8.82943 15.3521 8.82943C15.0672 8.82943 14.6621 8.9719 14.6621 9.58311V11.209H17.1417L16.8573 13.9753Z",
    fill: "#F6901F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup24);
export default __webpack_public_path__ + "static/media/Group (24).142d4a11f9b6c452440ad743f40d62aa.svg";
export { ForwardRef as ReactComponent };